import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

export const LoadMoreBtn = ({
  onClick,
  disabled,
}: { onClick: () => void; disabled: boolean }) => {
  const t = useTranslations('TemplateV2.testimonials')
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'bg-gray-800/40 text-gray-300 border border-cyan-500/30',
        'hover:bg-gray-700/60 hover:text-cyan-300 hover:border-cyan-500/50',
        'shadow-[0_0_10px_rgba(45,212,191,0.2)]',
        'hover:shadow-[0_0_15px_rgba(45,212,191,0.3)]',
        'transition-all duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'px-6 py-2 text-sm font-medium',
      )}
    >
      {disabled ? (
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 border-2 border-cyan-500/30 border-t-cyan-300 rounded-full animate-spin" />
          {t('loading')}
        </div>
      ) : (
        t('load_more')
      )}
    </Button>
  )
}
